// extracted by mini-css-extract-plugin
export var black = "_4b-6";
export var brand = "_4b-1";
export var ddefault = "_4b-0";
export var error = "_4b-3";
export var gray = "_4b-2";
export var highContrast = "_4b-8";
export var outline = "_4b-7";
export var success = "_4b-5";
export var warning = "_4b-4";